<mat-accordion class="example-headers-align" #firstAccordion="matAccordion" class="mat-elevation-z8" multi>
  <!-- we are having an issue with  #firstAccordion="matAccordion"  we dont know if we need it and consider a refactor -->
  <mat-expansion-panel class="mat-elevation-z8" (opened)="accOpened()" (closed)="accClosed()" [hideToggle]="false" #dude>
    <mat-expansion-panel-header class="mat-elevation-z8" class="table-icon">
      <mat-panel-title [ngClass]="is_open==true ? 'tableiconclose' : 'tableicon'">
        <mat-icon aria-hidden="false" aria-label="help">help</mat-icon>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <mat-card class="mat-elevation-z8">
      <ul>
        <li *ngFor="let help of helps">{{help}}</li>
      </ul>
      <ng-content></ng-content>
    </mat-card>
  </mat-expansion-panel>
</mat-accordion>
